import { useLocaleState, useRecordContext } from "react-admin";

import LabelField from "../../unit/LabelField";

const DefaultLog = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  return (
    <>
      <LabelField
        title="Data Operation"
        value={record.created_at}
        format="date"
        prefix="EST"
      />
      <LabelField title="Operator" value={record.sOper} />
      {record.sComment && record.sComment.length > 0 ? (
        <LabelField title="Comment" value={record.sComment} format="richtext" />
      ) : (
        <></>
      )}
      {record.sOverrideNotes && record.sOverrideNotes.length > 0 ? (
        <LabelField
          title="Comment"
          value={record.sOverrideNotes}
          format="richtext"
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default DefaultLog;
